

import { useLocation, Link, NavLink } from 'react-router-dom';
import {
  ListChecks,
  Book,
  BookMarked,
  Target,
  Users,
  Settings,
  Crown
} from 'lucide-react';
import { usePermissions } from '@/contexts/unified-permissions';

export const SidebarNavigation: React.FC = () => {
  const { isAdmin, isPremium } = usePermissions();
  const location = useLocation();

  return (
    <nav className="flex-1 px-4 py-4 overflow-y-auto">
      <ul className="space-y-1">
        <li>
          <Link
            to="/journal"
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/journal'
                ? 'bg-blue-600 text-white'
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <ListChecks className="h-5 w-5" />
            <span>Training Journal</span>
          </Link>
        </li>
        
        <li>
          <Link
            to="/techniques"
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/techniques'
                ? 'bg-blue-600 text-white'
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <Book className="h-5 w-5" />
            <span>Technique Library</span>
          </Link>
        </li>
        
        <li>
          <div className="relative">
            <NavLink
              to={isPremium ? "/my-techniques" : "/subscription"}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/my-techniques'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <BookMarked className="h-5 w-5" />
              <span>My Techniques</span>
              {!isPremium && (
                <Crown className="h-4 w-4 ml-auto text-yellow-500" />
              )}
            </NavLink>
          </div>
        </li>
        
        <li>
          <div className="relative">
            <NavLink
              to={isPremium ? "/game-planner2" : "/subscription"}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/game-planner2'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <Target className="h-5 w-5" />
              <span>Game Planner</span>
              {!isPremium && (
                <Crown className="h-4 w-4 ml-auto text-yellow-500" />
              )}
            </NavLink>
          </div>
        </li>

        <li>
          <NavLink 
            to="/affiliates"
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/affiliates' 
                ? 'bg-blue-600 text-white' 
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <Users className="h-5 w-5" />
            <span>Referral Program</span>
          </NavLink>
        </li>

        {/* Admin-only item - now consolidated */}
        {isAdmin && (
          <li>
            <NavLink 
              to="/roadmap-admin"
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/roadmap-admin' 
                  ? 'bg-blue-600 text-white' 
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <Settings className="h-5 w-5" />
              <span>Administration</span>
            </NavLink>
          </li>
        )}
      </ul>
    </nav>
  );
};
